import { useState } from 'react';

const SERVICIOS = [
  {
    id:       'tercerTiempo',
    nombre:   'Tercer Tiempo',
    desc:     'Asado, cervezas y empanadas para ambos equipos al finalizar',
    precio:   45000,
    icono:    '🍺',
  },
  {
    id:       'indumentaria',
    nombre:   'Indumentaria',
    desc:     'Petos, balones y accesorios para el partido',
    precio:   12000,
    icono:    '👕',
  },
];

export default function ServiciosDesafio({ desafio, onConfirmar, onSaltarse }) {
  const [seleccionados, setSeleccionados] = useState([]);

  const toggleServicio = (id) => {
    setSeleccionados(prev =>
      prev.includes(id)
        ? prev.filter(s => s !== id)
        : [...prev, id]
    );
  };

  const totalServicios = SERVICIOS
    .filter(s => seleccionados.includes(s.id))
    .reduce((sum, s) => sum + s.precio, 0);

  const precioCancha  = desafio.cancha?.precio  || 28000;
  const precioArbitro = desafio.conArbitro && desafio.arbitro
    ? desafio.arbitro.tarifa : 0;
  const margen    = 4000;
  const deposito  = Math.round((precioCancha + precioArbitro + margen) / 2);

  return (
    <div style={styles.wrap}>
      <div style={styles.titulo}>¡Desafío aceptado!</div>
      <div style={styles.sub}>
        Ahora puedes agregar servicios adicionales al partido.
        Esto es opcional — el desafío deportivo ya está confirmado.
      </div>

      {/* Resumen del partido confirmado */}
      <div style={styles.partidoConfirmado}>
        <div style={styles.partidoIcono}>✅</div>
        <div>
          <div style={styles.partidoTitulo}>
            vs {desafio.rival?.nombre}
          </div>
          <div style={styles.partidoMeta}>
            {desafio.fecha} · {desafio.hora} · {desafio.recinto?.nombre}
            {desafio.conArbitro && desafio.arbitro
              ? ` · Árbitro: ${desafio.arbitro.nombre}`
              : ' · Sin árbitro'}
          </div>
        </div>
      </div>

      {/* Servicios */}
      <div style={styles.serviciosList}>
        {SERVICIOS.map(({ id, nombre, desc, precio, icono }) => {
          const activo = seleccionados.includes(id);
          return (
            <div
              key={id}
              onClick={() => toggleServicio(id)}
              style={{
                ...styles.servicioCard,
                border:     `2px solid ${activo ? '#1A6BFF' : '#E8ECF4'}`,
                background: activo ? '#EFF5FF' : 'white',
              }}
            >
              <div style={styles.servicioIcono}>{icono}</div>
              <div style={styles.servicioInfo}>
                <div style={styles.servicioNombre}>{nombre}</div>
                <div style={styles.servicioDesc}>{desc}</div>
              </div>
              <div style={styles.servicioPrecioWrap}>
                <div style={{
                  ...styles.servicioPrecio,
                  color: activo ? '#1A6BFF' : '#141922',
                }}>
                  ${precio.toLocaleString('es-CL')}
                </div>
                <div style={styles.servicioPeriodo}>al finalizar</div>
              </div>
              {activo && <div style={styles.checkBadge}>✓</div>}
            </div>
          );
        })}
      </div>

      {/* Resumen financiero */}
      <div style={styles.resumen}>
        <div style={styles.resumenTitle}>Resumen financiero</div>
        <div style={styles.resumenRow}>
          <span>Depósito ya acordado (por equipo)</span>
          <span>${deposito.toLocaleString('es-CL')}</span>
        </div>
        {SERVICIOS.filter(s => seleccionados.includes(s.id)).map(s => (
          <div key={s.id} style={styles.resumenRow}>
            <span>{s.nombre}</span>
            <span style={{ color: '#6B7280' }}>
              ${s.precio.toLocaleString('es-CL')} al finalizar
            </span>
          </div>
        ))}
        {totalServicios > 0 && (
          <div style={{ ...styles.resumenRow, ...styles.resumenTotal }}>
            <span>Total servicios adicionales</span>
            <span style={{ color: '#FF6B1A' }}>
              ${totalServicios.toLocaleString('es-CL')}
            </span>
          </div>
        )}
        <div style={styles.resumenNota}>
          Los servicios se pagan al finalizar el partido, no en el depósito
        </div>
      </div>

      <div style={styles.botones}>
        <button style={styles.btnSaltar} onClick={onSaltarse}>
          Sin servicios extras
        </button>
        <button
          style={styles.btnConfirmar}
          onClick={() => onConfirmar(seleccionados)}
        >
          {seleccionados.length > 0
            ? `Confirmar ${seleccionados.length} servicio${seleccionados.length > 1 ? 's' : ''} →`
            : 'Continuar →'
          }
        </button>
      </div>
    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 28, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  sub: {
    fontSize: 13, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif",
    marginBottom: 20, lineHeight: 1.5,
  },
  partidoConfirmado: {
    display: 'flex', alignItems: 'center', gap: 14,
    background: '#F0FDF4', border: '1.5px solid #86EFAC',
    borderRadius: 14, padding: '14px 18px', marginBottom: 20,
  },
  partidoIcono: { fontSize: 24 },
  partidoTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 700, color: '#16A34A', marginBottom: 2,
  },
  partidoMeta: {
    fontSize: 12, color: '#4B7A5E',
    fontFamily: "'Barlow', sans-serif",
  },
  serviciosList: {
    display: 'flex', flexDirection: 'column',
    gap: 10, marginBottom: 20,
  },
  servicioCard: {
    display: 'flex', alignItems: 'center', gap: 14,
    borderRadius: 14, padding: '14px 16px',
    cursor: 'pointer', transition: 'all 0.15s',
    position: 'relative',
  },
  servicioIcono: { fontSize: 24, flexShrink: 0 },
  servicioInfo:  { flex: 1 },
  servicioNombre: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 16, fontWeight: 700, color: '#141922', marginBottom: 2,
  },
  servicioDesc: {
    fontSize: 12, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif", lineHeight: 1.4,
  },
  servicioPrecioWrap: { textAlign: 'right', flexShrink: 0 },
  servicioPrecio: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 800,
  },
  servicioPeriodo: {
    fontSize: 10, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
  },
  checkBadge: {
    position: 'absolute', top: 10, right: 10,
    background: '#1A6BFF', color: 'white',
    width: 20, height: 20, borderRadius: '50%',
    display: 'flex', alignItems: 'center',
    justifyContent: 'center', fontSize: 11, fontWeight: 700,
  },
  resumen: {
    background: '#F4F6FA', borderRadius: 12,
    padding: '14px 16px', marginBottom: 20,
  },
  resumenTitle: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 13, fontWeight: 700, color: '#6B7280',
    textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 10,
  },
  resumenRow: {
    display: 'flex', justifyContent: 'space-between',
    fontSize: 13, color: '#4A5568',
    fontFamily: "'Barlow', sans-serif", padding: '3px 0',
  },
  resumenTotal: {
    fontWeight: 700, color: '#141922',
    borderTop: '1px solid #E8ECF4',
    marginTop: 6, paddingTop: 8, fontSize: 14,
  },
  resumenNota: {
    fontSize: 11, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
    marginTop: 8, fontStyle: 'italic',
  },
  botones: {
    display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10,
  },
  btnSaltar: {
    padding: '12px', background: 'white',
    border: '1.5px solid #E8ECF4', borderRadius: 12,
    fontSize: 13, fontWeight: 700, color: '#6B7280',
    cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
  },
  btnConfirmar: {
    padding: '12px', background: '#1A6BFF',
    border: 'none', borderRadius: 12,
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 16, fontWeight: 800,
    color: 'white', cursor: 'pointer',
  },
};